import type { ChatRoomMemberInfo } from "@/hooks/use-chat-rooms";

interface Props {
  readers: ChatRoomMemberInfo[];
}

/**
 * Viser mini-avatarer for brukere som har lest opp til (og med) en melding.
 * Beregnes i ChatWindow ut fra member.last_read_at vs message.created_at.
 */
export function ReadReceipts({ readers }: Props) {
  if (readers.length === 0) return null;
  return (
    <div className="flex justify-end gap-0.5 pr-1 -mt-1">
      {readers.slice(0, 4).map((r) => {
        const initials = (r.full_name ?? "?")
          .split(" ")
          .map((n) => n[0])
          .join("")
          .slice(0, 2)
          .toUpperCase();
        return r.avatar_url ? (
          <img
            key={r.user_id}
            src={r.avatar_url}
            alt={r.full_name ?? ""}
            title={`Sett av ${r.full_name ?? "ukjent"}`}
            className="w-3.5 h-3.5 rounded-full object-cover ring-1 ring-background"
          />
        ) : (
          <span
            key={r.user_id}
            title={`Sett av ${r.full_name ?? "ukjent"}`}
            className="w-3.5 h-3.5 rounded-full bg-primary/20 text-primary text-[7px] font-medium inline-flex items-center justify-center ring-1 ring-background"
          >
            {initials}
          </span>
        );
      })}
      {readers.length > 4 && (
        <span className="text-[9px] text-muted-foreground self-end ml-0.5">
          +{readers.length - 4}
        </span>
      )}
    </div>
  );
}
